"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var d3 = _interopRequireWildcard(require("d3"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function scaleMin(scale) {
  return scale(d3.min(scale.domain()));
}

function scaleMax(scale) {
  return scale(d3.max(scale.domain()));
}

function getPositionBasics(scaleX, scaleY, isHorizontal) {
  return {
    isInvertedX: scaleMin(scaleX) > scaleMax(scaleX),
    isInvertedY: scaleMin(scaleY) < scaleMax(scaleY),
    x: isHorizontal ? scaleMax(scaleX) : scaleMin(scaleX),
    y: isHorizontal ? scaleMin(scaleY) : scaleMax(scaleY)
  };
}

function positionInner(scaleX, scaleY, horizontal) {
  var isMultiLine = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var attr = {};

  var _getPositionBasics = getPositionBasics(scaleX, scaleY, horizontal),
      isInvertedX = _getPositionBasics.isInvertedX,
      isInvertedY = _getPositionBasics.isInvertedY,
      x = _getPositionBasics.x,
      y = _getPositionBasics.y;

  if (horizontal) {
    attr.alignmentBaseline = isInvertedY ? 'hanging' : 'baseline';
  } else {
    attr.alignmentBaseline = isInvertedY ? 'baseline' : 'hanging';
  }

  if (horizontal) {
    attr.textAnchor = isInvertedX ? 'start' : 'end';
  } else {
    attr.textAnchor = isInvertedX ? 'end' : 'start';
  }

  var textPadding = 20;
  var dx, dy;

  if (horizontal) {
    dx = isInvertedX ? textPadding : -textPadding;
    dy = isInvertedY ? textPadding : -textPadding;
  } else {
    dx = isInvertedX ? -textPadding : textPadding;
    dy = isInvertedY ? -textPadding : textPadding;
  }

  attr.x = x + dx;
  attr.y = y + dy;

  if (isMultiLine) {
    dy = isInvertedY ? 16 : -16;
    return [_objectSpread(_objectSpread({}, attr), {}, {
      y: attr.y + 2 * dy
    }), _objectSpread(_objectSpread({}, attr), {}, {
      y: attr.y + dy
    }), attr];
  } else {
    return attr;
  }
}

function positionOuter(scaleX, scaleY, horizontal) {
  var isMultiLine = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var attr = {};

  var _getPositionBasics2 = getPositionBasics(scaleX, scaleY, horizontal),
      isInvertedX = _getPositionBasics2.isInvertedX,
      isInvertedY = _getPositionBasics2.isInvertedY,
      x = _getPositionBasics2.x,
      y = _getPositionBasics2.y;

  if (horizontal) {
    attr.alignmentBaseline = 'middle';
  } else {
    attr.alignmentBaseline = isInvertedY ? 'hanging' : 'baseline';
  }

  if (horizontal) {
    attr.textAnchor = isInvertedX ? 'end' : 'start';
  } else {
    attr.textAnchor = 'middle';
  }

  var textPadding = 20;
  var dx, dy;

  if (horizontal) {
    dx = isInvertedX ? -textPadding : textPadding;
    dy = 0;
  } else {
    dx = 0;
    dy = isInvertedY ? textPadding : -textPadding;
  }

  attr.x = x + dx;
  attr.y = y + dy;

  if (isMultiLine) {
    dy = isInvertedY ? 16 : -16;
    return [_objectSpread(_objectSpread({}, attr), {}, {
      y: attr.y - dy
    }), attr, _objectSpread(_objectSpread({}, attr), {}, {
      y: attr.y + dy
    })];
  } else {
    return attr;
  }
}

var AxisLabel = function AxisLabel(_ref) {
  var theme = _ref.theme,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      label = _ref.label,
      outer = _ref.outer,
      horizontal = _ref.horizontal;
  var style = {
    fontFamily: theme.font2,
    fontSize: '15px',
    fontWeight: '300',
    fill: theme.default,
    fillOpacity: '0.5'
  };
  var calcPosition = outer ? positionOuter : positionInner;
  var isMultiLine = label.split(' ').length === 3;

  if (isMultiLine) {
    var _calcPosition = calcPosition(xScale, yScale, horizontal, isMultiLine),
        _calcPosition2 = _slicedToArray(_calcPosition, 3),
        pos1 = _calcPosition2[0],
        pos2 = _calcPosition2[1],
        pos3 = _calcPosition2[2];

    var lines = label.split(' ');
    return /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("text", _extends({}, pos1, style), lines[0]), /*#__PURE__*/_react.default.createElement("text", _extends({}, pos2, style), lines[1]), /*#__PURE__*/_react.default.createElement("text", _extends({}, pos3, style), lines[2]));
  } else {
    return /*#__PURE__*/_react.default.createElement("text", _extends({}, calcPosition(xScale, yScale, horizontal), style), label);
  }
};

AxisLabel.propTypes = {
  xScale: _propTypes.default.func.isRequired,
  yScale: _propTypes.default.func.isRequired,
  label: _propTypes.default.string.isRequired,
  outer: _propTypes.default.bool,
  horizontal: _propTypes.default.bool
};
AxisLabel.defaultProps = {
  outer: false,
  horizontal: false
};

var _default = (0, _styledComponents.withTheme)(AxisLabel);

exports.default = _default;
//# sourceMappingURL=AxisLabel.js.map